import type {
  CreateTwoPreverificationAccountRequestType,
  CreateTwoPreverificationAccountResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useTwoCreatePreverificationAccount = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateTwoPreverificationAccountRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `two/merchant-customer/create-pre-verification-account`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<CreateTwoPreverificationAccountResponseType>(
            response,
          ).data,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.TwoPreverificationAccount,
        ],
      });
    },
  });
};
